export default {
  'page': 'page',
  'keep': 'keep',
  'kakao': 'kakao',
}
